import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'role-lov',
    templateUrl: './role-lov.component.html',
    styleUrls: ['./role-lov.component.scss']
})

export class RoleLovComponent extends GenericLovComponent {
  
  code        : string;
  name        : string;
  branchCode  : string;

  roles       : Role[] = [];
 
     columns = [
        {  prop: 'roleCode',      name: 'Code'},
        {  prop: 'name',          name: 'Name'},
        {  prop: 'profile.name',  name: 'profileCode'}
    ]

    constructor(
      public dialogRef            : MatDialogRef<RoleLovComponent>,
      protected masterDataService : MasterDataService,
      protected userService       : UserService,
      protected toastr            : ToastrService,
      protected router            : Router,
      protected location          : Location) {
        super();
      }
      

  //----------------------------------------------------------------------------------------------------------------
  loadData() {
        this.masterDataService.rolesGet(this.code, this.name, this.branchCode).then(result => {
            this.roles = result;
        }).catch(error => {
            this.toastr.error(error);
        })
    }
  //----------------------------------------------------------------------------------------------------------------


  //----------------------------------------------------------------------------------------------------------------
  filterOpened() : boolean {
      if (! this.roles) return true;
      if (this.roles.length == 0) return true;
    return false;
  }
  //----------------------------------------------------------------------------------------------------------------

  
  //----------------------------------------------------------------------------------------------------------------
  closeModal(role : Role){
    this.dialogRef.close(role);
  }
  //----------------------------------------------------------------------------------------------------------------

}
